/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';
import FilterActionHandler from '../FilterActionHandler';
import DeleteFilterAction from '../actions/DeleteFilterAction';
import EditFilterAction from '../actions/EditFilterAction';

export default types
	.model('LocalFiltersModel', {
		localFilters: types.optional(types.array(types.frozen()), [])
	})
	.volatile(() => ({
		content: null,
		dashboardApi: null,
		filterActionHandler: null
	}))
	.views((self) => ({
		getLocalFilters() {
			return self.localFilters;
		},
		getFilterActionHandler() {
			if(!self.content || !self.dashboardApi) {
				return null;
			}
			if(!self.filterActionHandler) {
				const cbGetActionsForFilter = self.getActionsForLocalFilter.bind(self);
				self.setFilterActionHandler(new FilterActionHandler({
					dashboard: self.dashboardApi,
					content: self.content,
					cbGetActionsForFilter
				}));
			}
			return self.filterActionHandler;
		},
		getActionsForLocalFilter(metadataColumn, filterId, itemId) {

			const availableActions = [];
			if (metadataColumn) {
				const editFilterAction = new EditFilterAction(self.dashboardApi, self.content, metadataColumn, filterId);
				if (editFilterAction.isEnabled()) {
					availableActions.push(editFilterAction);
				}
			}
			availableActions.push(
				new DeleteFilterAction(self.dashboardApi, self.content, metadataColumn, filterId, itemId)
			);

			return Promise.resolve(availableActions);
		}
	}))
	.actions((self) => {
		let eventCallback = null;
		return {
			beforeDestroy() {
				self.clearEvents();
			},
			setContent(content){
				self.content = content;
			},
			setUpEvents(callback) {
				if(self.content) {
					eventCallback = callback;
					self.content.on('change:visualization:localFilters:add', eventCallback);
					self.content.on('change:visualization:localFilters:edit', eventCallback);
					self.content.on('change:visualization:localFilters:remove', eventCallback);
				}
			},
			setDashboardApi(dashboardApi) {
				self.dashboardApi = dashboardApi;
			},
			setFilterActionHandler(filterActionHandler) {
				self.filterActionHandler = filterActionHandler;
			},
			setLocalFilters(localFilters = []) {
				self.localFilters = localFilters;
			},
			clear() {
				self.clearEvents();
				self.content = null;
				self.localFilters = [];
				self.filterActionHandler = null;
			},
			clearEvents() {
				if (self.content) {
					self.content.off('change:visualization:localFilters:add', eventCallback);
					self.content.off('change:visualization:localFilters:edit', eventCallback);
					self.content.off('change:visualization:localFilters:remove', eventCallback);
					eventCallback = null;
				}
			}
		};
	});



// WEBPACK FOOTER //
// ./src/js/models/LocalFiltersModel.js